/* USER */
export const USER_UID = 'USER_ID'
export const USER_DISPLAY_NAME = 'USER_DISPLAY_NAME'
export const USER_CLM = 'USER_CLM'
export const USER_ASTE = 'USER_ASTE'
export const USER_CLR = 'USER_CLR'

export const ASTA_SET = 'ASTA_SET'
export const ASTA_UPD = 'ASTA_UPD'
export const ASTA_LEGA_INFO_SET = 'ASTA_LEGA_INFO_SET'
export const ASTA_CLR = 'ASTA_CLR'

export const SQUADRE_SET = 'SQUADRE_SET'
export const SQUADRE_SEL = 'SQUADRE_SEL'
export const SQUADRE_CLR = 'SQUADRE_CLR'

export const PLAN_SET = 'PLAN_SET'
export const PLAN_CLR = 'PLAN_CLR'
export const PLAN_UPD = 'PLAN_UPD'

export const CUORI_SET = 'CUORI_SET'
export const CUORI_CLR = 'CUORI_CLR'

export const ROUND_SET = 'ROUND_SET'
export const ROUND_UPD = 'ROUND_UPD'
export const ROUND_CLR = 'ROUND_CLR'
export const ASTA_LOCAL_TIMERS_UPD = 'ASTA_LOCAL_TIMERS_UPD'

export const ONLINE_SET = 'ONLINE_SET'
export const MESSAGES_ADD = 'MESSAGES_ADD'
export const MESSAGES_SET = 'MESSAGES_SET'

export const CALCIATORI_ORIGINAL = 'CALCIATORI_ORIGINAL'
export const CALCIATORI_CUSTOM = 'CALCIATORI_CUSTOM'
export const CALCIATORI_CLR = 'CALCIATORI_CLR'
export const CALCIATORI_MAIN_STATUS = 'CALCIATORI_MAIN_STATUS'

export const LISTONE_CONF = 'LISTONE_CONF'

export const ASTA_LOGS_ALL = 'ASTA_LOGS_ALL'
export const ASTA_LOGS_LAST = 'ASTA_LOGS_LAST'
export const ASTA_LOGS_ALL_CLR = 'ASTA_LOGS_ALL_CLR'
export const ASTA_LOGS_LOADING = 'ASTA_LOGS_LOADING'
export const ASTA_LOGS_CLR = 'ASTA_LOGS_CLR'


export const PREFS_UPD = 'PREFS_UPD'
export const PREFS_CLR = 'PREFS_CLR'

export const SETTINGS_UPD = 'SETTINGS_UPD'
export const SCARTATI_SET = 'SCARTATI_SET'
